export default __webpack_public_path__ + "static/media/section35.7ef9fbec.svg";